'use client';

import { APP_PLATFORM } from '@/utils/constants';
import { PlatformBridgeBase } from './base';

export class PlatformBridgeXsell extends PlatformBridgeBase {
    platform = APP_PLATFORM.Xsell;
    commands = [
        'isSportsbook',
        'login',
        'joinNow',
        'openSBKWebView',
        'openExternalWebView',
        'sendGAEvent',
        'logAlchemerEvent'
    ];

    constructor() {
        super();
        this.bridge = window.AndroidSportsbook;
    }

    public isCompatible = () => !!this.bridge?.isSportsbook();

    protected isSportsbook() {
        return !!this.bridge.isSportsbook();
    }

    // in case the release on sportsbook is not done
    // at the same time with the casino web release
    // we need to allow the default behavior in place
    // to be removed after that
    protected hasOpenPromotionDetailsWebView() {
        return !!this.bridge.openPromotionDetailsWebView;
    }

    protected login() {
        this.bridge.login();
    }

    protected join() {
        this.bridge.joinNow();
    }

    protected canOpenAccountHub() {
        return false;
    }

    protected logAlchemerEvent(eventName: string) {
        this.bridge?.logAlchemerEvent?.(eventName);
    }

    protected sendGAEvent(dataObject: Record<string, unknown>) {
        if (this.bridge.sendGAEvent) {
            this.bridge.sendGAEvent(dataObject);
        }
    }

    protected openSBKWebView(url: string) {
        this.bridge.openSBKWebView(url);
    }

    protected openExternalWebView(url: string) {
        this.bridge.openExternalWebView(url);
    }

    protected openPromotionDetailsWebView(promoCode: string) {
        this.bridge.openPromotionDetailsWebView(promoCode);
    }

    protected savePreference(key: string, value: unknown) {
        this.bridge?.savePreference?.(key, value);
    }

    protected getPreference(key: string) {
        return this.bridge?.getPreference?.(key);
    }

    protected setStatusBarBackground(key: string) {
        return this.bridge?.setStatusBarBackground?.(key || '');
    }
}
